/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

const Sw01: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Magiczna Księga Baśni Olusia");
  const [text2, setText2] = useState<string>("na długie zimowe wieczory");
  const [text3, setText3] = useState<string>("od Babci Jadzi");
  const [fontSizeText1, setFontSizeText1] = useState<number>(54);
  const [fontSizeText2, setFontSizeText2] = useState<number>(52);
  const [fontSizeText3, setFontSizeText3] = useState<number>(44);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 900; // Maximum width for text
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'ComicSans'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'ComicSans'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'ComicSans'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, 54, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, 52, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, 44, 10));
  }, [text3]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth, // PDF width in mm
        pdfHeight: pdfHeight, // PDF height in mm
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null, // No image provided
      false // Disable the image requirement
    );
  };

  return (
        <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />

      <div style={{ position: "absolute", top: "20px", left: "20px" }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        className="bg-white sw-01"
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "ComicSans, MonotypeCorsiva",
        }}
      >
        <div className="sw-01-text-wrapper">
          <InlineEdit
            value={text1}
            setValue={setText1}
            classes="sw-01-text sw-01-text-1"
            style={{
              fontSize: `${fontSizeText1}px`,
              width: `${maxWidth}px`,
              height: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '70px',
              margin: 'auto',
              left: '0',
              right: '0'
            }}
          />
          <InlineEdit
            value={text2}
            setValue={setText2}
            classes="sw-01-text sw-01-text-2"
            style={{
              fontSize: `${fontSizeText2}px`,
              width: `${maxWidth}px`,
              height: "76px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '170px',
              margin: 'auto',
              left: '0',
              right: '0'
            }}
          />
          <InlineEdit
            value={text3}
            setValue={setText3}
            classes="sw-01-text sw-01-text-3"
            style={{
              fontSize: `${fontSizeText3}px`,
              width: `${maxWidth}px`,
              height: "76px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '240px',
              margin: 'auto',
              left: '0',
              right: '0'
            }}
          />
        </div>

        <img
          className="sw-01-bg"
          src="/images/BasnieSW01bg.png"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0' }}
        />
      </div>
    </div>
  );
};

export default Sw01;
